var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45757 96.7936L35.4951 122.831C39.0112 126.346 43.7795 128.321 48.7513 128.321C53.7232 128.321 58.4914 126.346 62.0076 122.831L142.42 42.4186C143.559 41.2398 144.189 39.6611 144.174 38.0223C144.16 36.3836 143.503 34.816 142.344 33.6572C141.185 32.4984 139.618 31.8411 137.979 31.8269C136.34 31.8127 134.761 32.4426 133.583 33.5811L53.1701 113.994C51.998 115.165 50.4086 115.824 48.7513 115.824C47.0941 115.824 45.5046 115.165 44.3326 113.994L18.2951 87.9561C17.1163 86.8176 15.5375 86.1877 13.8988 86.2019C12.2601 86.2161 10.6925 86.8734 9.53371 88.0322C8.37491 89.191 7.7176 90.7586 7.70336 92.3974C7.68912 94.0361 8.31909 95.6149 9.45757 96.7936Z",
    fill: "#20BF6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.ef2dc7ca9f1ce855347313b369d526c6.svg";
export { ForwardRef as ReactComponent };